import { Editor, Element, Transforms, Range } from 'slate';
import { inlineLinkType } from '../plugins/inlineLink/inlineLinkType';
import { AulaEditorInstance } from '../types';
import { hasLink } from './hasLink';

const unwrapLink = (editor: AulaEditorInstance, at: Range) => {
  Transforms.unwrapNodes(editor, {
    match: (n) =>
      !Editor.isEditor(n) && Element.isElement(n) && n.type === inlineLinkType,
    at,
  });
};

export const wrapLink = (
  editor: AulaEditorInstance,
  url: string,
  selection: Range
) => {
  if (hasLink(editor, selection)) {
    unwrapLink(editor, selection);
  }

  const link = {
    type: inlineLinkType,
    url,
    children: [{ text: url }],
  };

  Transforms.wrapNodes(editor, link, {
    at: selection,
    split: true,
  });

  Transforms.collapse(editor, { edge: 'end' });
};
